import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { NgIf, NgFor } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { SessionService } from '../../core/session.service';
import { QueueCardComponent } from '../../component/queue-card/queue-card.component';
import { PageSiteSwitcherComponent } from '../../component/page-site-switcher/page-site-switcher.component';
import { debounceTime, Subject, distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'app-accueil',
  standalone: true,
  imports: [NgIf, NgFor, QueueCardComponent, PageSiteSwitcherComponent, TranslatePipe],
  templateUrl: './accueil.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./accueil.component.scss'],
})
export class AccueilComponent {
  session = inject(SessionService);
  private fetchSubject = new Subject<string>();
  queues = this.session.queues;

  constructor() {
    // Debounce les appels fetchQueuesFor
    this.fetchSubject.pipe(
      distinctUntilChanged(),
      debounceTime(200)
    ).subscribe(estId => {
      this.session.fetchQueuesFor(estId);
    });

    effect(() => {
      const estId = this.session.selectedId();
      const dataVersion = this.session.dataVersion();
      
      if (estId) {
        this.fetchSubject.next(estId);
      }
    });
  }

  trackByIndex = (i: number, queue: any) => queue?.id;
}